import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BlogPost } from '@blog-models/blog-posts.model';
import { BlogService } from '@blog-services/blog/blog.service';
@Injectable({
    providedIn: 'root',
})
export class SearchService {
    public updatedSearchResults = new EventEmitter();

    private searchQuery = '';
    private searchResults: BlogPost[] = [];

    public constructor(
        private blogService: BlogService,
        private router: Router
    ) {}

    public getSearchQuery(): string {
        return this.searchQuery;
    }

    public setSearchQuery(query: string): void {
        this.searchQuery = query;
        this.blogService.getSearchResults(query).subscribe((result: BlogPost[]) => {
            this.searchResults = result;
            this.updatedSearchResults.emit();
        });
    }

    public getSearchResults(): BlogPost[] {
        return this.searchResults;
    }

    public clearSearchResults(): void {
        this.searchResults = [];
        this.clearSearchQuery();
        this.updateSearchResults();
    }

    public clearBrowserUrl(): void {
        this.router.navigate([], {
            queryParams: {
                search: null,
            },
            queryParamsHandling: 'merge',
        });
    }

    private clearSearchQuery(): void {
        this.searchQuery = '';
    }

    private updateSearchResults(): void {
        this.updatedSearchResults.emit();
    }
}
